module.exports = __webpack_public_path__ + "static/media/bg_1.5fe4e775.jpg";